import React from "react";
import { useTranslation } from "react-i18next";

export const useCopy = () => {
  const { t } = useTranslation();
  const [copySuccess, setCopySuccess] = React.useState<string>("");

  const handleCopy = () => {
    const currentUrl = window.location.href;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        setCopySuccess(t("Copied"));
        setTimeout(() => setCopySuccess(""), 2000); // Clear message after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  return {
    handleCopy,
    copySuccess,
  };
};
